import { takeEvery, call, select, put } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { selectActiveVenueId } from 'selectors/general';
import { excessInventory as excessInventoryEntity } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED } from 'features/App';
import Segment from 'helpers/segment';
import { setWeeksCount } from './ExcessInventory.reducers';

export const WEEKS_COUNT_CHANGED = 'WEEKS_COUNT_CHANGED';

export const weeksCountChanged = ({ weeksCount, scheduleId }) => ({
  type: WEEKS_COUNT_CHANGED,
  weeksCount,
  scheduleId,
});

export function* doFetchExcessInventory(client, action) {
  const { type, weeksCount = 1, scheduleId = null, venueId = null } = action;
  const fetchedVenueId = yield venueId || select(selectActiveVenueId);
  if (!fetchedVenueId) return;

  if (type === WEEKS_COUNT_CHANGED) {
    yield call(Segment.event, 'Click Historical reservations filter', {
      venueId,
      scheduleId,
      weeks: weeksCount,
    });
  }

  yield put(setWeeksCount(weeksCount));
  yield call(fetchEntity, excessInventoryEntity, [client, { venueId: fetchedVenueId, weeksCount, scheduleId }]);
}

export function* handleExcessInventoryRouteEnter(client) {
  yield call(doFetchExcessInventory, client, { weeksCount: 1 });
}

export function* watchExcessInventoryModule(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, doFetchExcessInventory, client);
  yield takeEvery(WEEKS_COUNT_CHANGED, doFetchExcessInventory, client);
}
